// extracted by mini-css-extract-plugin
export default {"header":"cqYJVfSNl","whiteStripeContainer":"cYpv6n6RN","whiteStripe":"cnRT_oI_f"};